<script setup lang="ts">
import { PageMeta } from '@/@vxapp/@Enums/PageMeta'
import AiMemoryPage from '@/components/AiWorkspace/Memory/AiMemoryPage.vue'

// The AI workspace's layout and access subject; the chat's keyboard shortcuts do not apply here.
definePage({
  meta: {
    subject: PageMeta.AiWorkspace.Chat.Meta.subject,
    layout: PageMeta.AiWorkspace.Chat.Meta.layout,
    pageTitle: 'Assistant memory',
  },
})
</script>

<template>
  <AiMemoryPage />
</template>
